<template>
  <div class="club_index">
    <page-header :title="$tc('club.name', 2)">
    </page-header>
    <page-content>
      <ntm-block :collapsable="false">
        <template slot="options">
          <input type="text" class="form-control" :placeholder="$tc('search')"  v-model="search">
          <button @click="createPage()" type="button" class="btn btn-sm btn-success">{{$t('action.addNew')}}</button>
          <button @click="mergePage()" type="button" class="btn btn-sm btn-warning" v-tooltip="$t('tooltip.mergeClubs')" data-testid="club-merge-button"><i class="fa fa-code-fork" aria-hidden="true"></i></button>
          <button @click="exportAll()" type="button" class="btn btn-sm btn-warning" v-tooltip="$t('action.export')"> <i class="fa fa-file" aria-hidden="true"></i></button>
          <button @click="openImportModal()" type="button" class="btn btn-sm btn-info" v-tooltip="$tc('import.name', 1)">
            <i class="fa fa-upload"></i>
          </button>
        </template>
        <div class="table-responsive">
          <ntm-table :show-columns="showColumns" :data="model" @pageChange="setPage" :loading="loading">
            <template slot="actions" slot-scope="{row}">
              <router-link :to="{ name: 'clubs.edit', params: {uuid: row.uuid }}" class="btn btn-sm btn-primary" v-tooltip="$t('action.edit')">
                <i class="fa fa-pencil"></i>
              </router-link>
            </template>
          </ntm-table>
        </div>
      </ntm-block>

      <modal name="import-modal" :adaptive="true" height="auto">
        <ntm-block :title="$tc('import.name', 1)" :collapsable="false">
          <template slot="options">
            <button @click="downloadClubTemplate()" type="button" class="btn btn-sm btn-warning mr-1">
              <i class="fa fa-download"></i>
              {{ $tc('template', 1) }}
            </button>
            <button type="button" class="btn btn-sm btn-light" @click="$modal.hide('import-modal')" v-tooltip="$t('close')">
              <i class="fa fa-times"></i>
            </button>
          </template>
          <p v-html="$tc('import.club.desc')"></p>
          <vue-dropzone
            :useCustomSlot="true"
            ref="myVueDropzone"
            class="mb-3"
            id="dropzone"
            :options="dropzoneClubOptions"
            @vdropzone-success="onImportSuccess"
          >
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">{{ $tc('import.club.window') }}</h3>
              <div class="subtitle">{{ $tc('import.orSelectFromPC') }}</div>
            </div>
          </vue-dropzone>
          <div class="text-right pb-3">
            <button type="button" class="btn btn-sm btn-secondary" @click="$modal.hide('import-modal')">{{ $t('close') }}</button>
          </div>
        </ntm-block>
      </modal>

      <modal name="import-skipped-modal" :adaptive="true" height="auto" width="80%">
        <ntm-block :title="$t('import.skippedRows')" :collapsable="false">
          <template slot="options">
            <button type="button" class="btn btn-sm btn-light" @click="$modal.hide('import-skipped-modal')" v-tooltip="$t('close')">
              <i class="fa fa-times"></i>
            </button>
          </template>
          <p class="text-muted mb-3">{{ $t('import.skippedDesc') }}</p>
          <div class="table-responsive">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th v-for="key in skippedRowKeys" :key="key">{{ key }}</th>
                  <th class="text-danger">{{ $t('import.missingFields') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in skippedRows" :key="index">
                  <td v-for="key in skippedRowKeys" :key="key">{{ item.row[key] }}</td>
                  <td class="text-danger">{{ item.missing.join(', ') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-right pb-3">
            <button type="button" class="btn btn-sm btn-secondary" @click="$modal.hide('import-skipped-modal')">{{ $t('close') }}</button>
          </div>
        </ntm-block>
      </modal>
    </page-content>
  </div>
</template>
<script>
import ClubService from '@/services/club.service'
import router from '@/router'
import basicIndexMixin from '@/mixins/basic.index.mixin'
import ExportService from '../../services/export.service'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { TokenService } from '@/services/storage.service'

export default {
  mixins: [basicIndexMixin],
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      skippedRows: [],
      showColumns: [
        {
          name: 'name',
          prop: 'name'
        },
        {
          name: 'shortName',
          prop: 'shortName'
        },
        {
          name: 'owner',
          prop: 'owner'
        }
      ]
    }
  },
  computed: {
    dropzoneClubOptions () {
      return {
        url: `${process.env.VUE_APP_BASE_URL}api/v2/admin/import/clubs`,
        headers: {
          'X-ORGANISATION': this.currentClient.uuid,
          Authorization: `Bearer ${TokenService.getToken()}`
        },
        acceptedFiles: 'text/csv'
      }
    },
    currentClient () {
      return this.$store.state.currentClient
    },
    skippedRowKeys () {
      if (!this.skippedRows.length) return []
      return Object.keys(this.skippedRows[0].row)
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      ClubService.index(this.search, this.page).then((response) => {
        this.setData(response.data)
      })
    },
    onImportSuccess (file, response) {
      this.$refs.myVueDropzone.removeFile(file)
      this.$modal.hide('import-modal')
      this.fetchData()

      if (response.skipped && response.skipped.length) {
        this.skippedRows = response.skipped
        this.$modal.show('import-skipped-modal')
      } else {
        this.$toast.fire({
          title: this.$t('imported.clubs'),
          icon: 'success'
        })
      }
    },
    exportAll () {
      ExportService.clubs().then(res => {
        const fileURL = window.URL.createObjectURL(new Blob([res.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'clubs.csv')
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    createPage () {
      router.push({ name: 'clubs.create' })
    },
    mergePage () {
      router.push({ name: 'clubs.merge' })
    },
    openImportModal () {
      this.$modal.show('import-modal')
    },
    downloadClubTemplate () {
      ExportService.clubTemplate().then(res => {
        const fileURL = window.URL.createObjectURL(new Blob([res.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'clubs.csv')
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    }
  }
}
</script>
